import React, {useEffect} from 'react';
import * as S from './ReviewPageAllLoaders.styles';
import HotelInfoLoader from '../HotelInfoLoader/HotelInfoLoader';
import SpecialRequestLoader from '../SpecialRequestLoader/SpecialRequestLoader';
import PaymentBlockLoader from '../PaymentBlockLoader/PaymentBlockLoader';
import PriceBlockLoader from '../PriceBlockLoader/PriceBlockLoader';
import OfferBlockLoader from '../OfferBlockLoader/OfferBlockLoader';

const ReviewPageAllLoaders = () => {
  window.scrollTo({top: 0});
  return (
    <>
      <S.BlueBackGroundWrapper />
      <S.ReviewBookingTextDiv>
        <S.ReviewBookingTextPara>Review your Booking</S.ReviewBookingTextPara>
      </S.ReviewBookingTextDiv>
      <S.ReviewMainComponentWrapDiv>
        <S.LeftSection>
          <HotelInfoLoader />
          <SpecialRequestLoader />
          <PaymentBlockLoader />
        </S.LeftSection>
        <S.RightSection>
          <PriceBlockLoader />
          <OfferBlockLoader />
        </S.RightSection>
      </S.ReviewMainComponentWrapDiv>
    </>
  );
};

export default ReviewPageAllLoaders;
